/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberAppointmentsIdQueryResponse, GetApiBarberAppointmentsIdPathParams, GetApiBarberAppointmentsId400, GetApiBarberAppointmentsId401, GetApiBarberAppointmentsId403, GetApiBarberAppointmentsId404, GetApiBarberAppointmentsId500 } from "../entities/GetApiBarberAppointmentsId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiBarberAppointmentsId } from "../api/getApiBarberAppointmentsId";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiBarberAppointmentsIdQueryKey = (id: GetApiBarberAppointmentsIdPathParams["id"] | undefined) => [{ url: '/api/barber/appointments/:id', params: {id:id} }] as const

export type GetApiBarberAppointmentsIdQueryKey = ReturnType<typeof getApiBarberAppointmentsIdQueryKey>

export function getApiBarberAppointmentsIdQueryOptions(id: GetApiBarberAppointmentsIdPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiBarberAppointmentsIdQueryKey(id)
        return queryOptions<GetApiBarberAppointmentsIdQueryResponse, ResponseErrorConfig<GetApiBarberAppointmentsId400 | GetApiBarberAppointmentsId401 | GetApiBarberAppointmentsId403 | GetApiBarberAppointmentsId404 | GetApiBarberAppointmentsId500>, GetApiBarberAppointmentsIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiBarberAppointmentsId(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получить детали записи для мастера
 * @summary Получить запись
 * {@link /api/barber/appointments/:id}
 */
export function useGetApiBarberAppointmentsId<TData = GetApiBarberAppointmentsIdQueryResponse, TQueryData = GetApiBarberAppointmentsIdQueryResponse, TQueryKey extends QueryKey = GetApiBarberAppointmentsIdQueryKey>(id: GetApiBarberAppointmentsIdPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetApiBarberAppointmentsIdQueryResponse, ResponseErrorConfig<GetApiBarberAppointmentsId400 | GetApiBarberAppointmentsId401 | GetApiBarberAppointmentsId403 | GetApiBarberAppointmentsId404 | GetApiBarberAppointmentsId500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiBarberAppointmentsIdQueryKey(id)
         

         const query = useQuery({
          ...getApiBarberAppointmentsIdQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiBarberAppointmentsId400 | GetApiBarberAppointmentsId401 | GetApiBarberAppointmentsId403 | GetApiBarberAppointmentsId404 | GetApiBarberAppointmentsId500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}